import request from '@/utils/ajax';

export function editWechat(data){
  return request({
    url: `/wx/manage/wxBotClientInfo/update`,
    method: 'put',
    data: data
  });
}

export function loginWechat(id){
  return request({
    url: `/wx/manage/wxBotClientInfo/initLogin/${id}`,
    method: 'put',
  });
}

export function loginOutWechat(id){
  return request({
    url: `/wx/manage/wxBotClientInfo/logout/${id}`,
    method: 'put',
  });
}
